export default {
  id: "calculated-number",
  name: "Calculated Field",
  settings: {}
};
